<template>
  <div class="empty-state">
    <div class="empty-state-icon">
      <v-icon size="30" color="#9aa2ab">{{ icon }}</v-icon>
    </div>
    <span class="empty-state-title">{{ title }}</span>
    <span v-if="text" class="empty-state-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: { type: String, default: "mdi-cursor-default-click-outline" },
    title: { type: String, required: true },
    text: { type: String, default: "" },
  },
};
</script>

<style scoped lang="scss">
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 54px 24px;
  background: #fff;
  border: 1px dashed #d4d9dd;
  border-radius: 14px;

  &-icon {
    width: 54px;
    height: 54px;
    border-radius: 14px;
    background: #f2f4f5;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
  }

  &-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #384049;
  }

  &-text {
    font-size: 0.83rem;
    color: #8a929b;
    max-width: 420px;
    line-height: 1.5;
  }
}
</style>
